import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

export const PricesTrendPreliminaryPill = () => {
    const {isMobile} = useUserDevice();

    return (
        <div className={pillStyle}>
            <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                {isMobile ? "Wstępne" : "Dane wstępne"}
            </Text>

            <DsTooltip
                popover={
                    <Message type="info" className={messageStyle}>
                        Ostatnie miesiące to dane wstępne. Rejestr Cen Nieruchomości (RCN) dopisuje transakcje z opóźnieniem, a przy małej liczbie aktów
                        pojedyncza sprzedaż mocno przesuwa średnią — te wartości mogą się jeszcze zmienić.
                    </Message>
                }
                type="info"
                placement="top"
                zIndex={10}
            >
                {({refs, getReferenceProps}) => (
                    <span ref={refs.setReference} className={infoTriggerStyle} {...getReferenceProps()}>
                        <InfoIcon size="1.4" fill="var(--colors-gray-600)" />
                    </span>
                )}
            </DsTooltip>
        </div>
    );
};

const pillStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    px: 1.5,
    py: "0.5rem",
    borderRadius: "100px",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-300)",
    whiteSpace: "nowrap"
});

const infoTriggerStyle = css({
    display: "inline-flex",
    cursor: "pointer"
});

const messageStyle = css({
    maxWidth: "300px !important"
});
import {css} from "@panda/css";

import {DsTooltip} from "@pg-design/floating-module";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

export const PricesTrendPreliminaryPill = () => {
    const {isMobile} = useUserDevice();

    return (
        <div className={pillStyle}>
            <Text variant="info_txt_1" as="span" color="var(--colors-gray-700)">
                {isMobile ? "Wstępne" : "Dane wstępne"}
            </Text>

            <DsTooltip
                popover={
                    <Message type="info" className={messageStyle}>
                        Ostatnie miesiące to dane wstępne. Rejestr Cen Nieruchomości (RCN) dopisuje transakcje z opóźnieniem, a przy małej liczbie aktów
                        pojedyncza sprzedaż mocno przesuwa średnią — te wartości mogą się jeszcze zmienić.
                    </Message>
                }
                type="info"
                placement="top"
                zIndex={10}
            >
                {({refs, getReferenceProps}) => (
                    <span ref={refs.setReference} className={infoTriggerStyle} {...getReferenceProps()}>
                        <InfoIcon size="1.4" fill="var(--colors-gray-600)" />
                    </span>
                )}
            </DsTooltip>
        </div>
    );
};

const pillStyle = css({
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    px: 1.5,
    py: "0.5rem",
    borderRadius: "100px",
    backgroundColor: "var(--colors-white)",
    border: "1px solid var(--colors-gray-300)",
    whiteSpace: "nowrap"
});

const infoTriggerStyle = css({
    display: "inline-flex",
    cursor: "pointer"
});

const messageStyle = css({
    maxWidth: "300px !important"
});
